/**
 * @description
 * Generates product slug based on the current route
 *
 * @param   {Object} vm        vue component runtime object
 *
 * @returns  {string}   Formatted product module name
 */
export function getProductModuleName(vm) {
    const slug = vm?.$route?.params?.slug ?? 'unknown';
    return `product--${slug}`;
}

/**
 * @description
 * Generates product slug based on the current route
 *
 * @param   {Object} route        vue route
 *
 * @returns  {string}   Formatted product module name
 */
export function getProductModuleNameFromRoute(route) {
    const slug = route?.params?.slug ?? 'unknown';
    return `product--${slug}`;
}
